import { Helmet } from 'react-helmet';

const Canonical = () => {
    const canonicalSplitUrl = () => {
        if (window?.location?.pathname?.endsWith('/')) {
            return window?.location?.pathname?.slice(0, -1);
        } else {
            return window?.location?.pathname;
        }
    };

    const canonicalLink = () => {
        const pathname: any = canonicalSplitUrl();
        if (window?.location?.pathname?.includes('/en')) {
            return `${((window?.location?.origin + pathname)?.toString()?.replace("/en", ""))}`
        } else if (window?.location?.pathname?.includes('/hi')) {
            return `${(window?.location?.origin + pathname)}`
        } else if (window?.location?.pathname?.includes('/mr')) {
            return `${(window?.location?.origin + pathname)}`
        } else {
            return `${(window?.location?.origin + pathname)}`
        }
    }

    const alternate = () => {
        const pathname: any = canonicalSplitUrl();
        if (window?.location?.pathname?.includes('/en')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/en", ""))
        } else if (window?.location?.pathname?.includes('/hi')) {
            return (window?.location?.origin + pathname)
        } else if (window?.location?.pathname?.includes('/mr')) {
            return (window?.location?.origin + pathname)
        } else {
            return (window?.location?.origin + pathname)
        }
    }

    const alternateEn = () => {
        const pathname: any = canonicalSplitUrl();
        if (window?.location?.pathname?.includes('/en')) {
            return (window?.location?.origin + pathname)
        } else if (window?.location?.pathname?.includes('/hi')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/hi", "/en"))
        } else if (window?.location?.pathname?.includes('/mr')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/mr", "/en"))
        } else {
            return (window?.location?.origin + "/en" + pathname)
        }
    }

    const alternateHi = () => {
        const pathname: any = canonicalSplitUrl();
        if (window?.location?.pathname?.includes('/en')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/en", "/hi"))
        } else if (window?.location?.pathname?.includes('/hi')) {
            return (window?.location?.origin + pathname)
        } else if (window?.location?.pathname?.includes('/mr')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/mr", "/en"))
        } else {
            return (window?.location?.origin + "/hi" + pathname)
        }
    }

    const alternateMr = () => {
        const pathname: any = canonicalSplitUrl();
        if (window?.location?.pathname?.includes('/en')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/en", "/mr"))
        } else if (window?.location?.pathname?.includes('/hi')) {
            return ((window?.location?.origin + pathname)?.toString()?.replace("/hi", "/mr"))
        } else if (window?.location?.pathname?.includes('/mr')) {
            return (window?.location?.origin + pathname)
        } else {
            return (window?.location?.origin + "/mr" + pathname)
        }
    }

    return (
        <Helmet>
            <link rel="canonical" href={canonicalLink()} />
            <link hrefLang="x-default" rel="alternate" href={alternate()} />
            <link hrefLang="en" rel="alternate" href={alternateEn()} />
            <link hrefLang="hi" rel="alternate" href={alternateHi()} />
            <link hrefLang="mr" rel="alternate" href={alternateMr()} />
        </Helmet>
    );
};

export default Canonical;